import React from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '$contexts/locale.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const SkipLink = props => {
    const { formatURI } = useLocale();

    return (
        <a
            className='link-reset skip-link type-style-body'
            href={formatURI(props.href)}>
            {props.children}
        </a>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

SkipLink.propTypes = {
    href: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]).isRequired
};

export default SkipLink;
